import React, { useEffect } from 'react'
import { Field, useFormikContext } from 'formik'
import styles from './CheckoutForm.module.css'
import { Radio } from '@local/do-secundo-form'
import { CheckoutFormValues, getTipAmount } from './utils'
import { CheckoutProps } from './useCheckoutProps'
import { t } from '@local/translations'

interface PaymentToggleProps {
  checkoutProps: CheckoutProps
}

/**
 * Payment method selection toggle for checkout flow.
 * Displays credit card vs other payment options with contextual messaging.
 */
export const PaymentToggle = ({ checkoutProps }: PaymentToggleProps) => {
  const { values, setFieldValue } = useFormikContext<CheckoutFormValues>()
  const { showPaymentToggle, restaurantInfo, checkoutPaymentAmount, isIntlRx } =
    checkoutProps
  const restaurantName = restaurantInfo?.name
  const paymentType = values.paymentType
  const showIntlPaymentMessage = isIntlRx && paymentType === 'CREDIT'

  useEffect(() => {
    const tipAmount = getTipAmount(values)

    if (tipAmount > 0 && paymentType !== 'CREDIT') {
      setFieldValue('paymentType', 'CREDIT')
    } else if (
      tipAmount === 0 &&
      checkoutPaymentAmount.totalAmountDue === 0 &&
      paymentType === 'CREDIT'
    ) {
      setFieldValue('paymentType', 'ZERO_DOLLAR_ORDER')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.paymentTip])

  if (!showPaymentToggle) return null

  return (
    <>
      <div className={styles['radio-tabs']}>
        <Field
          data-testid='payment-type-CC'
          style='tab'
          component={Radio}
          name='paymentType'
          id='payment_type_cc'
          label={t('payment-toggle.credit-card')}
          value='CREDIT'
        />
        <Field
          data-testid='payment-type-other'
          style='tab'
          component={Radio}
          name='paymentType'
          id='payment_type_other'
          label={t('payment-toggle.other')}
          value='OTHER'
        />
      </div>
      {paymentType === 'OTHER' && (
        <div className='pt-2'>
          {t('payment-toggle.payment-follow-up', {
            restaurantName: restaurantName || t('payment-toggle.the-restaurant')
          })}
        </div>
      )}
      {showIntlPaymentMessage && (
        <div className='pt-2'>
          {t('payment-toggle.payment-collected-next-step')}
        </div>
      )}
    </>
  )
}
